<template>
    <span>
        <input v-if="isEditing"
               v-model="form.title"
               @keydown.enter="save"
               @keydown.esc="cancel"
               ref="title"
               id="title"
               name="title"
               autocomplete="off"
               class="lc-edit-title form__input"
               :class="{'form__input--error' : form.errors.has('title')}"/>
        <h1 v-else @click.prevent.stop="edit" class="job__title">{{ job.title }}</h1>
    </span>
</template>

<script>
/* global EventBus */
import { mapState } from 'vuex'
import Form from '../../helpers/Form'

export default {
    name: 'Title',

    data () {
        return {
            isEditing: false,
            form: new Form({
                title: ''
            })
        }
    },

    created () {
        EventBus.$on('AppClick', (event) => {
            if (!this.$el.contains(event.target)) {
                this.cancel()
            }
        })
    },

    methods: {
        edit () {
            this.form.title = this.job.title
            this.isEditing = true
        },

        save () {
            if (this.form.title === this.job.title) {
                this.isEditing = false
                return
            }
            this.$store.dispatch('job/renameJob', this.form).then(() => {
                window.history.replaceState({}, this.job.title, this.job.url);
                this.isEditing = false
            })
        },

        cancel () {
            this.isEditing = false
        }
    },

    computed: {
        ...mapState('job', ['job'])
    }
}
</script>
